var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.BoxedLayout,[_c(_setup.Logo),_c('router-view',{staticClass:"router-content"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }